import { render, staticRenderFns } from "./ProductDownloads.vue?vue&type=template&id=20d2b092&scoped=true&"
import script from "./ProductDownloads.vue?vue&type=script&lang=js&"
export * from "./ProductDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d2b092",
  null
  
)

export default component.exports